/**
 * Provides service functions for user authentication and session-related
 * operations, including login tracking, logout handling, role switching,
 * and retrieval of Fluxx user identifiers.
 */
import { api } from "@/api";

export interface PostLoginResponse {
  success: boolean;
}

export async function postLoginUser(): Promise<PostLoginResponse> {
  const res = await api.postLogin();
  return res as PostLoginResponse;
}

export async function postLogoutUser(): Promise<PostLoginResponse> {
  const res = await api.postLogout();
  return res as PostLoginResponse;
}

export async function getFluxxUserId(userPrincipalName: string): Promise<string> {
  const res = await api.getFluxxUserId(userPrincipalName);
  return res as string;
}

export async function postUserRoleSwitch( role: string) {
  const res = await api.postRoleSwitch(role);
  return res;
}
